var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSlider',_vm._b({key:_vm.$attrs.max,attrs:{"reverse":_vm.reversed},on:{"callback":function($event){return _vm.handleInput($event)}}},'VueSlider',{ ..._vm.$props, ..._vm.$attrs, ..._vm.sliderProps },false))
}
var staticRenderFns = []

export { render, staticRenderFns }